import { render } from "./DeliveryMail.vue?vue&type=template&id=061153a5"
import script from "./DeliveryMail.vue?vue&type=script&lang=js"
export * from "./DeliveryMail.vue?vue&type=script&lang=js"
script.render = render

export default script